var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPencilSign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-26.9%",
    y: "-15.2%",
    width: "153.8%",
    height: "130.4%",
    filterUnits: "objectBoundingBox",
    id: "m76fll8fib"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-26.9%",
    y: "-24.8%",
    width: "153.9%",
    height: "149.6%",
    filterUnits: "objectBoundingBox",
    id: "sregiigt9d"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-37.4%",
    y: "-215%",
    width: "174.7%",
    height: "530%",
    filterUnits: "objectBoundingBox",
    id: "laqmetcfoe"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "vo5nlj284a",
    d: "M0 0h7.987v14.141H0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "djt8o65z2c",
    d: "M0 14.141h7.987l-3.891 8.662z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.322 4.034h5.354",
    id: "dsdom96zbf"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "rotate(45 6.447 21.644)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D5DFFE",
    xlinkHref: "#vo5nlj284a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#m76fll8fib)",
    xlinkHref: "#vo5nlj284a"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#111C5B",
    strokeWidth: 1.3,
    xlinkHref: "#vo5nlj284a"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(45 6.447 21.644)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D5DFFE",
    xlinkHref: "#djt8o65z2c"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#sregiigt9d)",
    xlinkHref: "#djt8o65z2c"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#111C5B",
    strokeWidth: 1.3,
    xlinkHref: "#djt8o65z2c"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "rotate(45 6.447 21.644)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#laqmetcfoe)",
    xlinkHref: "#dsdom96zbf"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#111C5B",
    strokeWidth: 1.3,
    xlinkHref: "#dsdom96zbf"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilSign);
export default __webpack_public_path__ + "static/media/pencil-sign.7020c895509067d72565136ec423ae94.svg";
export { ForwardRef as ReactComponent };